import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { useAuth } from '@components/Auth';
import VnrLink from '@components/VnrLink';
import { Menu } from 'antd';
import React, { useEffect, useState } from 'react';

import dataMenu from './dataMenu';
import style from './MenuLeft.module.scss';

const { SubMenu } = Menu;

const MenuLeft = () => {
  //get history from local storage
  const [menuLeftCollapseStatus, setMenuLeftCollapseStatus] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem("menuLeftCollapseStatus");
      // Parse stored json or if none return initialValue
      if (item === 'true') {
        return true;
      } else return false;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return false;
    }
  });
  const [selectedKey, setSelectedKey] = useState();
  const { user } = useAuth();
  const pathname = typeof window !== undefined ? '' : window.location.pathname;
  
  const toggleMenuLeftStatus = () => {
    setMenuLeftCollapseStatus(!menuLeftCollapseStatus);
    window.localStorage.setItem("menuLeftCollapseStatus", !menuLeftCollapseStatus);
  };

  useEffect(() => {
    let path = window.location.pathname;
    if (path.startsWith('/')) {
      path = path.replace('/', '');
    }
    if (path.endsWith('/')) {
      path = path.replace('/', '');
    }
    setSelectedKey(path);
  }, [pathname]);
  if (!user || !user.id) {
    return null;
  }
  
  const roles = user.roles.map((item) => item.code);

  const dataMenuUI = dataMenu.filter((menu) => {
    if (!menu.roles) {
      return true;
    }
    return menu.roles.some((role) => roles.includes(role));
  });
  
  return (
    <div className={style['vnr-comp-MenuLeft']}>
      <Menu
        mode="inline"
        theme="light"
        inlineCollapsed={menuLeftCollapseStatus}
        selectedKeys={[selectedKey]}
        className={style['menu-left-wrapper']}
      >
        <Menu.Item
          icon={menuLeftCollapseStatus ? <RightOutlined /> : <LeftOutlined />}
          className={style['vnr-btn-collapse']}
          onClick={() => toggleMenuLeftStatus()}
          key="btn-toggle"
        ></Menu.Item>

        {dataMenuUI.map((item) => {
          return item.children ? (
            <SubMenu
              icon={<span className={style['menu-icon']}>{item.icon}</span>}
              key={item.key}
              title={
                <VnrLink to={item.link}>
                  <span className={style['content']}>{item.content}</span>
                </VnrLink>
              }
            >
              {item.children.map((child) => {
                return (
                  <Menu.Item 
                    icon={<span className={style['menu-icon']}>{child.icon}</span>}
                    key={child.key}
                  >
                    <VnrLink to={child.link}>
                      <span className={style['content']}>{child.content}</span>
                    </VnrLink>
                  </Menu.Item>
                );
              })}
            </SubMenu>
          ) : (
            <Menu.Item 
              icon={<VnrLink to={item.link}>{item.icon}</VnrLink>}
              key={item.key} 
              className={style['menu-left-item']}
            >
              <VnrLink to={item.link}>
                <span className={style['content']}>{item.content}</span>
              </VnrLink>
            </Menu.Item>
          );
        })}
      </Menu>
    </div>
  );
};

export default MenuLeft;
